// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2b7Ld","approved":"Status_approved__2XT03","rejected":"Status_rejected__1Z2fS","expired":"Status_expired__2dpty","label":"Status_label__fnAZU"};